import SearchBar from "../plugins/search";

document.addEventListener('DOMContentLoaded', () => {
    const searchBar = new SearchBar({
        searchInputSelector: '#autoComplete',
        dataUserTypeSelector: '[data-user]'
    });
    searchBar.init();
})